// The price to OFFER for a labor line that has time but no price (22 Oct):
// typically a line a tech logged in Lightspeed. Offered with a "Use this
// price" button in the line editor, never applied on its own, because opening
// a line must not change what the customer pays and some $0 lines are
// deliberate (warranty, comped work).
//
// Returns null when there is nothing to offer: not a labor line, no shop rate,
// no time on the line, a price already set, or the timer's own $0 line.
export function laborPriceSuggestion({ lineType, hours, minutes, unitPrice, isTimerLine }, rate) {
  if ((lineType || 'labor') !== 'labor' || isTimerLine) return null;
  const r = parseFloat(rate);
  if (!(r > 0)) return null;
  const h = Math.max(0, parseInt(hours, 10) || 0);
  const m = Math.max(0, parseInt(minutes, 10) || 0);
  const totalHours = h + m / 60;
  if (!(totalHours > 0)) return null;
  if ((parseFloat(unitPrice) || 0) > 0) return null;
  const price = (Math.round(totalHours * r * 100) / 100).toFixed(2);
  const time = h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`;
  return { price, label: `${time} × $${r}/hr = $${price}` };
}
